"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGING_BUCKETS = void 0;
exports.daysBetween = daysBetween;
exports.bucketOf = bucketOf;
exports.ageOpenItems = ageOpenItems;
const money_1 = require("../money");
/** حدود الشرائح بالأيام بعد الاستحقاق — عرض قياسى (30/60/90)، لا قاعدة محاسبية. */
exports.AGING_BUCKETS = [
    'current',
    'days1to30',
    'days31to60',
    'days61to90',
    'over90',
];
/** أيام بين تاريخين بالتقويم — التواريخ أيام لا لحظات، فلا منطقة زمنية. */
function daysBetween(from, to) {
    const start = Date.UTC(Number(from.slice(0, 4)), Number(from.slice(5, 7)) - 1, Number(from.slice(8, 10)));
    const end = Date.UTC(Number(to.slice(0, 4)), Number(to.slice(5, 7)) - 1, Number(to.slice(8, 10)));
    return Math.round((end - start) / 86_400_000);
}
function bucketOf(dueDate, asOf) {
    const overdue = daysBetween(dueDate, asOf);
    if (overdue <= 0)
        return 'current';
    if (overdue <= 30)
        return 'days1to30';
    if (overdue <= 60)
        return 'days31to60';
    if (overdue <= 90)
        return 'days61to90';
    return 'over90';
}
function emptyBuckets() {
    return {
        current: money_1.Money.zero(),
        days1to30: money_1.Money.zero(),
        days31to60: money_1.Money.zero(),
        days61to90: money_1.Money.zero(),
        over90: money_1.Money.zero(),
    };
}
/**
 * أعمار الأرصدة المفتوحة فى تاريخ (عملاء أو موردين): كل فاتورة مفتوحة فى شريحة أيام تأخرها، والدائن غير
 * المخصص يُخصم من إجمالى العميل. عميل بلا رصيد مفتوح ولا دائن لا يظهر.
 */
function ageOpenItems(asOf, items, unapplied) {
    const byCustomer = new Map();
    const entry = (partyId) => {
        let aging = byCustomer.get(partyId);
        if (!aging) {
            aging = {
                partyId,
                buckets: emptyBuckets(),
                unappliedCredit: money_1.Money.zero(),
                total: money_1.Money.zero(),
            };
            byCustomer.set(partyId, aging);
        }
        return aging;
    };
    for (const item of items) {
        const open = money_1.Money.of(item.openBalance);
        if (open.isZero())
            continue;
        const aging = entry(item.partyId);
        const bucket = bucketOf(item.dueDate, asOf);
        aging.buckets[bucket] = aging.buckets[bucket].add(open);
    }
    for (const [partyId, credit] of unapplied) {
        const value = money_1.Money.of(credit);
        if (value.isZero())
            continue;
        entry(partyId).unappliedCredit = value;
    }
    for (const aging of byCustomer.values()) {
        aging.total = money_1.Money.sum(exports.AGING_BUCKETS.map((bucket) => aging.buckets[bucket])).sub(aging.unappliedCredit);
    }
    return [...byCustomer.values()];
}
//# sourceMappingURL=aging.js.map